import {
  CreateSearchIntentResponse,
  CreateSearchIntentWSChannel,
} from "../services/flights/createSearchIntentResponse";

type CountedIntegration =
  | "skyscanner"
  | "vaiDePromo"
  | "zupper"
  | "flipmilhas"
  | "ourtrip"
  | "123milhas"
  | "maxmilhas"
  | "viaza";

const getIntegrationResultsCount = (
  wsChannels: CreateSearchIntentWSChannel[],
  integration: CountedIntegration,
) =>
  wsChannels.reduce(
    (total, channel) =>
      total + (channel.cacheData[integration]?.data.length ?? 0),
    0,
  );

export const getSearchEndedEventData = (
  response: CreateSearchIntentResponse,
) => {
  const wsChannels = response.message.wsChannels ?? [];
  const skyscanner = getIntegrationResultsCount(wsChannels, "skyscanner");
  const vaiDePromo = getIntegrationResultsCount(wsChannels, "vaiDePromo");
  const zupper = getIntegrationResultsCount(wsChannels, "zupper");
  const flipmilhas = getIntegrationResultsCount(wsChannels, "flipmilhas");
  const ourtrip = getIntegrationResultsCount(wsChannels, "ourtrip");
  const _123milhas = getIntegrationResultsCount(wsChannels, "123milhas");
  const maxmilhas = getIntegrationResultsCount(wsChannels, "maxmilhas");
  const viaza = getIntegrationResultsCount(wsChannels, "viaza");

  return {
    gtmResults: {
      sk: skyscanner,
      vaiDePromo,
      zupper,
      flipmilhas,
      ourtrip,
      "123milhas": _123milhas,
      maxmilhas,
      viaza,
    },
  };
};
